import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PulsePerfTrendComponent} from './pulse-perf-trend.component';
import {HighchartsChartModule} from "highcharts-angular";
import {AlertBannerModule} from "../../lib/alert-banner";


@NgModule({
  declarations: [PulsePerfTrendComponent],
  imports: [
    CommonModule,
    HighchartsChartModule,
    AlertBannerModule.forRoot(),
  ],
  exports: [PulsePerfTrendComponent]
})
export class PulsePerfTrendModule {
}
